import { NumberSimpleInputProps, SimpleInput } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

type NumberInputProps = Pick<
  NumberSimpleInputProps,
  | 'onChange'
  | 'onBlur'
  | 'name'
  | 'label'
  | 'required'
  | 'precision'
  | 'min'
  | 'max'
  | 'id'
  | 'value'
  | 'errorMessage'
>;

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>((props, ref) => (
  <SimpleInput ref={ref} size="sm" type="number" useSeparator {...props} />
));
